import React, { useState } from "react";
import styled from "styled-components";
import ArrowBottom from 'assets/PolygonActive.svg'

type Option = {
    label: string;
    value: string;
};

type DropdownProps = {
    options: Option[];
    placeholder?: string;
    onChange?: (value: string) => void;
    initialValue?: string;
};

export const Dropdown: React.FC<DropdownProps> = ({
                                                      options,
                                                      placeholder = "Select option",
                                                      onChange,
                                                      initialValue,
                                                  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState<Option | null>(
        options.find(o => o.value === initialValue) || null
    );

    const handleSelect = (option: Option) => {
        setSelected(option);
        setIsOpen(false);
        onChange?.(option.value);
    };

    return (
        <Wrapper>
            <Control onClick={() => setIsOpen(prev => !prev)}>
                <span>{selected?.label || placeholder}</span>
                <StyledArrow $open={isOpen} />

            </Control>

            {isOpen && (
                <Menu>
                    {options.map(option => (
                        <Item
                            key={option.value}
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </Item>
                    ))}
                </Menu>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
  position: relative;
  width: 116px;
  height:30px;
  font-family: sans-serif;
`;

const Control = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #A4A4A4 ;
  color: #000000;
  font-weight: 600;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  height: 30px;
  background: none;
`;

const Arrow = styled.span<{ $open: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${props => (props.$open ? "180deg" : "0deg")});
`;

const Menu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;

  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  z-index: 10;
  padding:7px 6px;
`;

const Item = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 6px;
  color: #000000;
  font-weight: 400;

  &:hover {
    background: rgba(226, 229, 255, 1);
  }
`;

const StyledArrow = styled(ArrowBottom)<{ $open: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${props => (props.$open ? "0deg"  :"180deg" )});

    path {
        fill: #00000050;
    }
`;
